module.exports = __webpack_public_path__ + "img/caret-down.dab4b369.svg";